//
import { LangComJa } from '@/locales/lang-com-ja';
export const ja = {
  com: LangComJa,
  seo: {
    title: 'INSPIRE LLC > INSPIRE LLCについて',
    description: ` 自動車流通業界のプロフェッショナルギルド[INSPIRE LLC]について`,
    keywords: `INSPIRE LLC,インスパイア,自動車,輸出,貿易,中古車,東京,プロフェッショナルギルド,DAO,システム,エンジニア`,
  },
  row1: {
    title: 'プロフェッショナルギルド',
    m1: 'プロフェッショナルギルドとは、社会課題に対応し、新しい価値を生み出すために、さまざまな専門技術を持つプロフェッショナルが協力する組織です。',
    m2: '「INSPIRE LLC」は、自動車流通業界に特化したプロフェッショナルギルドとして自動車流通業界の発展のため、日々奮闘しています。',
    m3: '',
  },
  row2: {
    title: 'DAO(自律分散型組織)',
    m1: 'DAOとは、「Decentralized Autonomous Organization」の略で、組織をネットワークと捉え、意思決定を並列化し特定の管理者や中央機関に依存しない運営を実現します。',
    m2: '「INSPIRE LLC」はDAOを組織の柔軟性を高めつつ各分野のプロフェッショナルが相互に良い影響を与えクリエイティブな活動を実現しています。',
    m3: '',
  },
  row3: {
    title: '会社概要',
    left: {
      CompanyName: '会社名',
      HeadOffice: '本社所在地',
      YearEstablished: '設立',
      Ceo: '代表',
      Tel: '電話番号',
      FAX: 'FAX番号',
      EMail: 'メールアドレス',
      OpenHours: '営業時間',
      HolidaySat: '休日',
      Business: '',
    },
    right: {
      CompanyName: 'INSPIRE合同会社（INSPIRE LLC）',
      HeadOffice: '〒124-0013 東京都葛飾区東立石3丁目11番7号',
      YearEstablished: '2009年（平成21年）',
      Ceo: '田島 利将',
      EMail: 'sales@inspire-llc.jp',
      OpenHours: '10:00〜18:00',
      HolidaySat: '土日祝日（メール対応あり）',
      Business: '',
    },
  },
};
